import {
  Box,
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react"
import { FiChevronDown, FiPrinter } from "react-icons/fi"

type PrintLanguageSelectProps = {
  onPrintPL: () => void | Promise<void>
  onPrintEN: () => void | Promise<void>
  isDisabledPL?: boolean
  isDisabledEN?: boolean
  size?: "sm" | "md" | "lg"
  minW?: string
}

export default function PrintLanguageSelect({
  onPrintPL,
  onPrintEN,
  isDisabledPL = false,
  isDisabledEN = false,
  size = "sm",
  minW = "140px",
}: PrintLanguageSelectProps) {
  const iconColor = useColorModeValue("gray.500", "gray.200")

  const handlePrintPL = async () => {
    if (isDisabledPL) return
    await onPrintPL()
  }

  const handlePrintEN = async () => {
    if (isDisabledEN) return
    await onPrintEN()
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        size={size}
        minW={minW}
        variant="wmsDropdown"
        rightIcon={<FiChevronDown />}
        isDisabled={isDisabledPL && isDisabledEN}
        justifyContent="space-between"
        fontWeight="500"
        aria-label="Wybór języka druku"
      >
        <Box display="inline-flex" alignItems="center" gap={2}>
          <Icon as={FiPrinter} color={iconColor} aria-hidden />
          <Text>Druk...</Text>
        </Box>
      </MenuButton>
      <MenuList>
        <MenuItem onClick={handlePrintPL} isDisabled={isDisabledPL}>
          Druk PL
        </MenuItem>
        <MenuItem onClick={handlePrintEN} isDisabled={isDisabledEN}>
          Druk EN
        </MenuItem>
      </MenuList>
    </Menu>
  )
}
